import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokens: "",
    datas: {},
    user: {
      "userBase": {
        "userId": "",
        "mobile": ""
      },
      "userProfile": {
        "profileId": "",
        "userId": "",
        "nickname": "",
        "avatarUrl": "",
        "createTime": "",
        "updateTime": ""
      }
    },
    setviplever:{
      
    }
  },
  getters: {
  },
  mutations: {
    SETTOKENS(state, tokens) {
      state.tokens = tokens
    },
    SETDATAS(state, datas) {
      state.datas = datas
    },
    SETUSER(state, user) {
      state.user = user
    },
    SETVIPLEVER(state, setviplever) {
      state.setviplever = setviplever
    }
  },
  actions: {
    refreshToken(state, tokens) {

    },
    //手机号登录
    loginByPhone() {

    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js